import { Controller } from "@hotwired/stimulus"

// Handles product dropdown selection in proposal pages
// Automatically updates the preview when a product is selected
export default class extends Controller {
  static targets = ["select"]
  static values = {
    baseUrl: String
  }

  selectProduct() {
    const productId = this.selectTarget.value
    if (!productId) return

    // Update URL with new product_id and trigger Turbo navigation
    const url = new URL(this.baseUrlValue, window.location.origin)
    url.searchParams.set("product_id", productId)
    url.searchParams.set("view", "product")

    // Navigate via Turbo to update the preview frame
    const frame = document.querySelector('turbo-frame#preview_content')
    if (frame) {
      frame.src = url.toString()
    }
  }
}
